import React, { useLayoutEffect, useRef, useState } from 'react';
import FiltrosMapa from '../../components/map/FiltrosMapa';
import useGoogleMaps from '../../hooks/useGoogleMaps';
import ModalNoPropiedades from './../../screens/ModalNoPropiedades';
import MapaGoogle from './MapaGoogle';

const crearIconoMarcador = (etiqueta, esDestacado = '') => ({
  url: `data:image/svg+xml,${encodeURIComponent(`
    ${esDestacado ? `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <path fill="#EAB308" d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"></path>
        <text x="288" y="390" font-size="120" font-family="Arial" font-weight="bold" text-anchor="middle" fill="#FFFFFF">${etiqueta}</text>
      </svg>`
      : `
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="35" viewBox="0 0 120 80">
        <rect x="10" y="10" rx="20" ry="20" width="90" height="55" fill="${esDestacado ? '#EAB308' : '#25c1f6'}" />
        <text x="55" y="45" font-size="23" font-family="Arial" font-weight="bold" text-anchor="middle" fill="#FFFFFF">${etiqueta}</text>
      </svg>
      `}
  `)}`,
  scaledSize: new window.google.maps.Size(esDestacado ? 52 : 60, esDestacado ? 52 : 40),
});

const Mapa = ({ setZonaVisible, expanded, datosPropiedades, filtros, setFiltros, buscando }) => {
  const filtrosRef = useRef();
  const [alturaMapa, setAlturaMapa] = useState('100%');
  const [mostrarModal, setMostrarModal] = useState(false);
  const [datosMapa, setDatosMapa] = useState(null);

  const isMobile = window.innerWidth <= 768;


  useLayoutEffect(() => {
    const actualizarAlturaMapa = () => {
      if (filtrosRef.current) {
        const alturaFiltros = isMobile
          ? (filtrosRef.current?.offsetHeight || 84)
          : (filtrosRef.current?.offsetHeight || 164);

        let alturaDisponible;

        if (isMobile && window.visualViewport) {
          alturaDisponible = window.visualViewport.height - alturaFiltros;
          setAlturaMapa(`${alturaDisponible}px`);
        } else {
          alturaDisponible = window.innerHeight - alturaFiltros;
          setAlturaMapa(`calc(100% - ${alturaFiltros}px)`);
        }

      }
    };

    actualizarAlturaMapa();
    window.addEventListener('resize', actualizarAlturaMapa);
    window.addEventListener('load', actualizarAlturaMapa);

    return () => {
      window.removeEventListener('resize', actualizarAlturaMapa);
      window.removeEventListener('load', actualizarAlturaMapa);
    };
  }, [isMobile]);

  const limpiarPoligonosYMarcadores = () => {
    if (mapaGoogleRef.current) {
      mapaGoogleRef.current.limpiarPoligonosYMarcadores();
    }
  };

  const manejarCambioDatos = (nuevosDatos) => {
        console.log("que son los nuevos datos", nuevosDatos);
        setDatosMapa(nuevosDatos);
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            addressComponents: nuevosDatos.addressComponents
        }));

        setTimeout(()=>{
          console.log("despues de 3 segundos que son los filtros", filtros)
        },3000)
    };

  const googleMapsLoaded = useGoogleMaps();
  const mapaGoogleRef = useRef();

  return (
    <>
      <div className={`relative ${expanded ? 'hidden md:block md:w-4/12' : 'md:w-9/12'} w-full h-full overscroll-none touch-none`}>
        <div ref={filtrosRef}>
          {googleMapsLoaded && (
            <FiltrosMapa
              filtros={filtros}
              setFiltros={setFiltros}
              limpiarPoligonosYMarcadores={limpiarPoligonosYMarcadores}
              expanded={expanded}
              datosMapa={datosMapa}
            />
          )}
        </div>
        <div className='w-full' style={{ height: alturaMapa }}>
          {googleMapsLoaded && (
            <MapaGoogle
              ref={mapaGoogleRef}
              datosPropiedades={datosPropiedades}
              setZonaVisible={setZonaVisible}
              ubicacionBusqueda={filtros.ubicacionBusqueda ?? ''}
              expanded={expanded}
              tipoRenta={filtros.tipoRenta}
              crearIconoMarcador={crearIconoMarcador}
              buscando={buscando}
              onDatosCambiados={manejarCambioDatos}
            />
          )}
        </div>
      </div>
      <ModalNoPropiedades mostrar={mostrarModal} onClose={() => setMostrarModal(false)} />
    </>
  );
};

export default Mapa;
